import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type AccountAssetLifecyclePolicyFragment = { __typename?: 'Account', id: string, assetLifecyclePolicy?: number | null, permissions?: { __typename?: 'AccountPermissions', canManageResourceControlPolicies: boolean } | null };

export type WorkspaceAssetLifecyclePolicyFragment = { __typename?: 'Workspace', id: string, daysBeforeAssetAutoDeletion?: number | null };

export const AccountAssetLifecyclePolicy = /*#__PURE__*/ gql`
    fragment AccountAssetLifecyclePolicy on Account {
  id
  assetLifecyclePolicy
  permissions {
    canManageResourceControlPolicies
  }
}
    ` as unknown as DocumentNode<AccountAssetLifecyclePolicyFragment, unknown>;
export const WorkspaceAssetLifecyclePolicy = /*#__PURE__*/ gql`
    fragment WorkspaceAssetLifecyclePolicy on Workspace {
  id
  daysBeforeAssetAutoDeletion
}
    ` as unknown as DocumentNode<WorkspaceAssetLifecyclePolicyFragment, unknown>;

        

        
export const useAccountAssetLifecyclePolicyFragment = (
  input: string | Omit<UseFragmentOptions<AccountAssetLifecyclePolicyFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Account' } };
    return input;
  })();

  return useFragment<AccountAssetLifecyclePolicyFragment>({
    fragment: AccountAssetLifecyclePolicy,
    fragmentName: 'AccountAssetLifecyclePolicy',
    ...options,
  });
};
  
        
        

        
export const useWorkspaceAssetLifecyclePolicyFragment = (
  input: string | Omit<UseFragmentOptions<WorkspaceAssetLifecyclePolicyFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Workspace' } };
    return input;
  })();

  return useFragment<WorkspaceAssetLifecyclePolicyFragment>({
    fragment: WorkspaceAssetLifecyclePolicy,
    fragmentName: 'WorkspaceAssetLifecyclePolicy',
    ...options,
  });
};
  
        